import React from 'react';

import { onMessage, getMessaging, isSupported } from 'firebase/messaging';
import toast from 'react-hot-toast';
import { NotificationPriorities } from '@pharmaplan/common';

import ToastNotification from '../../components/ToastNotification';
import genericClasses from '../../theme/GenericClasses';
import ThemeConstants from '../../theme/ThemeConstants';

const seconds = 10;
const ms = 1000;
const duration = seconds * ms;

const useForegroundNotifications = () => {
  isSupported().then(() => {
    const messaging = getMessaging();
    let style = {};
    onMessage(messaging, (payload) => {
      const { data } = payload ?? {};
      const { priority = NotificationPriorities.normal } = data ?? {};

      const isPriority = priority === NotificationPriorities.critical;

      style = isPriority
        ? {
          ...genericClasses.toastWidth,
          backgroundColor: ThemeConstants.common.priorityBg,
          borderLeft: `3px solid ${ThemeConstants.common.counterRed}`,
          color: ThemeConstants.common.grey850,
        }
        : {
          ...genericClasses.toastWidth,
          backgroundColor: ThemeConstants.common.lightGreen,
          color: ThemeConstants.primary.main,
        };

      toast((t) =>
        <ToastNotification data={data as any} toastParams={t} />, {
        duration: isPriority ? Infinity : duration,
        style,
      });
    });
  });
};

export default useForegroundNotifications;
